var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment_bank"},[_c('v-row',[_c('v-col',[_c('MainOrgInfo',{attrs:{"likeComponent":true},on:{"valid":function($event){return _vm.setValid($event)},"organization":function($event){return _vm.setOrg($event)}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }